import React from "react";
import "../../../assets/css/custom.css";

const RegistrationComplete = ({
  showRedirectInput,
  redirectUrl,
  isRedirectUrlValid,
  handleRedirectCheckboxChange,
  handleRedirectUrlChange,
  displayRegistrationId,
  handleDisplayRegistrationIdChange,
}) => {
  return (
    <div className="row clearfix">
      <div className="col-lg-12">
        <div className="card registration-card">
          {/* <div className="card-header setting_card_heading">
            <div className="col-lg-9 p-0">
              <h5 className="mb-0">Registration Complete Page</h5>
            </div>
          </div> */}
          <div className="card-body border-0">
            <div className="row row-custom">
              <div className="col-lg-5">
                <div className="switch-container">
                  <label className="switch">
                    <input
                      type="checkbox"
                      className="lv-btn small-switch"
                      checked={displayRegistrationId}
                      onChange={handleDisplayRegistrationIdChange}
                    />
                    <span className="slider round"></span>
                  </label>
                  <span className="ml-2">Display registration ID</span>
                </div>
              </div>
              <div className="col-lg-7">
                <p className="text-secondary" style={{ margin: 0 }}>
                  If enabled, registration ID will be displayed on the success page.
                </p>
              </div>
            </div>
            <div className="row row-custom">
              <div className="col-lg-5">
                <div className="switch-container">
                  <label className="switch">
                    <input
                      type="checkbox"
                      className="lv-btn small-switch"
                      checked={showRedirectInput}
                      onChange={handleRedirectCheckboxChange}
                    />
                    <span className="slider round"></span>
                  </label>
                  <span className="ml-2">
                    Redirection after registration is completed
                  </span>
                </div>
              </div>
              <div className="col-lg-7">
                <p className="text-secondary" style={{ margin: 0 }}>
                  If enabled, users will be redirected to the provided link
                  after the registration process is complete (e.g., to your
                  website, social media page, etc).
                </p>
              </div>
            </div>

            {showRedirectInput && (
              <div className="row row-custom">
                <div className="col-lg-5">
                  <label htmlFor="redirectUrl" className="form-label">
                    Redirect to this link
                  </label>
                </div>
                <div className="col-lg-7">
                  <input
                    type="url"
                    id="redirectUrl"
                    className={`form-control ${!isRedirectUrlValid ? "is-invalid" : ""}`}
                    value={redirectUrl}
                    onChange={handleRedirectUrlChange}
                    placeholder="Add a URL"
                    required
                  />
                  {!isRedirectUrlValid && (
                    <div className="invalid-feedback">
                      This field is required and must be a valid URL.
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationComplete;